<template>
  <div class="preservation-applicant">
    <MyTitle theTitle="被申请人" />
      <van-cell-group class="fd-com-scroll">
        <van-field
          v-model="formData.sqrlxText"
          required
          clearable
          readonly
          label="被申请人类型"
          right-icon="arrow"
          placeholder="请选择类型"
          @click="selectSqrlx"
        ></van-field>
        <van-popup v-model="showSqrlx" position="bottom">
          <van-picker
            show-toolbar
            :columns="columnsRYLX"
            :default-index="0"
            @cancel="showSqrlx = false"
            @confirm="onSelectSqrlx"
          ></van-picker>
        </van-popup>
        <div v-if="sqrLx == 1">
          <van-field
            v-model="formData.xm"
            required
            label="姓名"
            placeholder="请输入姓名"
          ></van-field>
          <van-field
            v-model="formData.zjlxText"
            readonly
            required
            label="证件类型"
            right-icon="arrow"
            placeholder="请选择证件类型"
            @click="showZJLXPicker = true"
          ></van-field>
          <van-popup v-model="showZJLXPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_105000"
              :default-index="0"
              @cancel="showZJLXPicker = false"
              @confirm="onZJLXConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.zjhm"
            required
            label="证件号码"
            placeholder="请输入证件号码"
            @input="identifyAnalyzer"
          ></van-field>
          <van-field
            v-model="formData.dtDsrbirthdayText"
            clearable
            readonly
            right-icon="arrow"
            label="出生日期"
            placeholder="请选择出生日期"
            @click="showDatePicker = true"
          ></van-field>
          <van-popup v-model="showDatePicker" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              :min-date="minDate"
              :max-date="maxDate"
              type="date"
              @cancel="showDatePicker = false"
              @confirm="onDatePickerConfirm"
            ></van-datetime-picker>
          </van-popup>
          <van-field
            v-if="formData.zjlx == 1"
            v-model="formData.nl"
            clearable
            label="年龄"
            placeholder="请输入年龄"
          ></van-field>
          <van-field
            v-if="formData.zjlx != 1"
            v-model="formData.nl"
            clearable
            label="年龄"
            placeholder="请输入年龄"
          ></van-field>
          <van-field required label="性别" v-if="formData.zjlx === 1">
            <van-radio-group
              slot="input"
              v-model="formData.xb">
              <van-radio
                v-for="item in codeList_110000"
                :name="item.keyId"
                :key="item.keyId">
                {{item.text }}
              </van-radio>
            </van-radio-group>
          </van-field>
          <van-field required label="性别" v-else> 
            <van-radio-group
              slot="input"
              v-model="formData.xb">
              <van-radio
                v-for="item in codeList_110000"
                :name="item.keyId"
                :key="item.keyId">
                {{ item.text }}
              </van-radio>
            </van-radio-group>
          </van-field>
          <van-field
            v-model="formData.mzText"
            readonly
            label="民族"
            right-icon="arrow"
            placeholder="请选择民族"
            @click="showMZPicker = true"
          ></van-field>
          <van-popup v-model="showMZPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_120000"
              :default-index="0"
              @cancel="showMZPicker = false"
              @confirm="onMZConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.sjhm"
            label="手机号码"
            placeholder="请输入手机号码"
          ></van-field>
          <!-- <van-field
                            v-model="formData.gddh"
                            label="固定电话"
                            placeholder="请输入固定电话"
                    ></van-field> -->
          <section class="fd-com-section">
            <div class="fd-com-title">
              固定电话
            </div>
            <van-field
              v-model="formData.cGh1"
              label="区号"
              placeholder="请输入区号"
            ></van-field>
            <van-field
              v-model="formData.cGh2"
              label="电话号码"
              placeholder="请输入电话号码"
            ></van-field>
            <van-field
              v-model="formData.cGh3"
              label="分机号"
              placeholder="请输入分机号"
            ></van-field>
          </section>
          <van-field
            v-model="formData.jcjzd"
            label="经常居住地"
            placeholder="请输入经常居住地"
          ></van-field>
        </div>
        <div v-if="sqrLx == 2">
          <van-field
            v-model="formData.qymc"
            required
            label="单位名称"
            placeholder="请输入单位名称"
          ></van-field>

          <!--                    <van-field
                            v-model="formData.tyshxydm"
                            required
                            label="统一社会信用代码"
                            placeholder="请输入统一社会信用代码"
                    ></van-field>-->
          <van-field
            v-model="formData.nZzlxText"
            required
            readonly
            label="证照类型"
            right-icon="arrow"
            placeholder="请选择证照类型"
            @click="showZZPicker = true"
          ></van-field>
          <van-popup v-model="showZZPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_109000"
              :default-index="nZzlx"
              @cancel="showZZPicker = false"
              @confirm="onZZConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.tyshxydm"
            required
            label="证照号码"
            placeholder="请输入证照号码"
          ></van-field>

          <van-field
            v-model="formData.dwxzText"
            readonly
            label="单位性质"
            right-icon="arrow"
            placeholder="请选择单位性质"
            @click="showGZDWPicker = true"
          ></van-field>
          <van-popup v-model="showGZDWPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_108000"
              :default-index="0"
              @cancel="showGZDWPicker = false"
              @confirm="onGZDWConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.fddbr"
            required
            label="法定代表人"
            placeholder="请输入法定代表人姓名"
          ></van-field>
          <van-field
            v-model="formData.sjhm"
            label="手机号码"
            placeholder="请输入手机号码"
          ></van-field>
          <!-- <van-field
                            v-model="formData.gddh"
                            label="固定电话"
                            placeholder="请输入固定电话"
                    ></van-field> -->
          <section class="fd-com-section">
            <div class="fd-com-title">
              固定电话
            </div>
            <van-field
              v-model="formData.cGh1"
              label="区号"
              placeholder="请输入区号"
            ></van-field>
            <van-field
              v-model="formData.cGh2"
              label="电话号码"
              placeholder="请输入电话号码"
            ></van-field>
            <van-field
              v-model="formData.cGh3"
              label="分机号"
              placeholder="请输入分机号"
            ></van-field>
          </section>
          <van-field
            v-model="formData.dwdz"
            required
            label="单位地址"
            placeholder="请输入单位地址"
          ></van-field>
        </div>
        <div v-if="sqrLx == 3">
          <van-field
            v-model="formData.qymc"
            required
            label="单位名称"
            placeholder="请输入单位名称"
          ></van-field>

          <!--                    <van-field
                            v-model="formData.tyshxydm"
                            required
                            label="统一社会信用代码"
                            placeholder="请输入统一社会信用代码"
                    ></van-field>-->
          <van-field
            v-model="formData.nZzlxText"
            required
            readonly
            label="证照类型"
            right-icon="arrow"
            placeholder="请选择证照类型"
            @click="showZZPicker = true"
          ></van-field>
          <van-popup v-model="showZZPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_109000"
              :default-index="nZzlx"
              @cancel="showZZPicker = false"
              @confirm="onZZConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.tyshxydm"
            required
            label="证照号码"
            placeholder="请输入证照号码"
          ></van-field>

          <van-field
            v-model="formData.dwxzText"
            readonly
            label="单位性质"
            right-icon="arrow"
            placeholder="请选择单位性质"
            @click="showGZDWPicker = true"
          ></van-field>
          <van-popup v-model="showGZDWPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_108000"
              :default-index="0"
              @cancel="showGZDWPicker = false"
              @confirm="onGZDWConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.zyfzr"
            required
            label="主要负责人"
            placeholder="请输入主要负责人姓名"
          ></van-field>
          <van-field
            v-model="formData.sjhm"
            label="手机号码"
            placeholder="请输入手机号码"
          ></van-field>
          <!-- <van-field
                            v-model="formData.gddh"
                            label="固定电话"
                            placeholder="请输入固定电话"
                    ></van-field> -->
          <section class="fd-com-section">
            <div class="fd-com-title">
              固定电话
            </div>
            <van-field
              v-model="formData.cGh1"
              label="区号"
              placeholder="请输入区号"
            ></van-field>
            <van-field
              v-model="formData.cGh2"
              label="电话号码"
              placeholder="请输入电话号码"
            ></van-field>
            <van-field
              v-model="formData.cGh3"
              label="分机号"
              placeholder="请输入分机号"
            ></van-field>
          </section>
          <van-field
            v-model="formData.dwdz"
            required
            label="单位地址"
            placeholder="请输入单位地址"
          ></van-field>
        </div>
      </van-cell-group>
      <div class="fd-com-btn-container">
        <van-button
          v-if="bsqrId"
          type="info"
          round
          plain
          :disabled="!saveBtnClickable"
          @click="addBsqrAndReturn"
        >
          确定
        </van-button>
        <van-button
          v-if="!bsqrId"
          type="info"
          round
          plain
          :disabled="!saveBtnClickable"
          @click="addBsqrAndReturn"
        >
          添加
        </van-button>
        <van-button
          v-if="!bsqrId"
          type="info"
          round
          :disabled="!saveBtnClickable"
          @click="addBsqrAndContinue"
        >
          确认并继续添加
        </van-button>
      </div>
  </div>
</template>

<script>
import MyTitle from "../../../components/common/myTitle";
import { columnsRYLX } from "../../../utils/option.js";
import {
  typeRylx,
  typeMz,
  typeZzlx,
  typeSfzjlx,
  typeGzdwlx,
} from "../../../filters/index";
import validate from "@/utils/validator/validator";
import {
  PhoneRule,
  ZjhmRule,
  XmRule,
  xbRule,
  zjlxRule,
  csrqRule,
  TxdzRule,
  QymcRule,
  nZzlxRule,
  CQyzzjgdmRule,
  TyshxydmRule,
  QyfrRule,
  GddhRule, // 固定电话
  QhRule, // 区号
  DhhmRule, //电话号码
  FjhRule, // 分机号
} from "@/utils/validator/rules";
import { dateFormat } from "../../../utils/dateFormatter";
import { checkIdentify, getIDData } from "../../../utils/common";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      bqid: "",
      bsqrId: "",
      formData: {
        // 姓名
        xm: "",
        // 性别
        xb: "1",
        // 民族
        mz: "1",
        mzText: "汉族", // 民族文字描述
        // 年龄
        nl: "",
        dtDsrbirthday: "", // 被申请人出生日期,
        dtDsrbirthdayText: "", // 被申请人出生日期文字描述
        // 证件类型
        zjlx: 1,
        // 证件类型汉字描述
        zjlxText: "居民身份证",
        // 证件号码
        zjhm: "",
        // 固定电话
        gddh: "",
        // 手机号码
        sjhm: "",
        // 经常居住地
        jcjzd: "",
        // 单位名称
        qymc: "",

        // 证照类型
        nZzlx: 4,
        // 证照号码
        nZzlxText: "社会统一信用代码证",

        // 统一社会信用代码
        tyshxydm: "",
        // 单位性质
        dwxz: "",
        dwxzText: "", // 单位性质文字描述
        // 法定代表人
        fddbr: "",
        // 单位地址
        dwdz: "",
        // 主要负责人
        zyfzr: "",
        // 申请人类型描述
        sqrlxText: "自然人",
        cGh1: "",
        cGh2: "",
        cGh3: "",
      },
      postData: {
        cDsrlx: "", // 申请人类型
        cDsrxm: "", // 申请人姓名
        nMz: "", // 民族
        cDsrxb: "", // 性别
        nNl: "", // 年龄
        dtDsrbirthday: "", // 申请人出生日期
        cZjlx: "", // 证件类型
        cZjh: "", // 证件号

        nZzlx: "", // 证照类型
        nZzlxText: "", //证照类型名称

        cGh: "", // 固话
        cPhoneno: "", // 电话号
        cJtdwdz: "", // 家庭单位地址,接口字段废弃,使用下方通讯地址字段
        cTxdz: "", // 通讯地址,所有地址用这个字段提交
        cQymc: "", // 单位名称
        cZzjgdm: "", // 企业组织机构代码(也就是统一社会信用代码)
        cDwxz: "", // 单位性质
        cQyfr: "", // 企业法人(也是主要负责人)
      },
      showSqrlx: false,
      actionsSqrlx: [
        { id: 1, name: "自然人" },
        { id: 2, name: "法人" },
        { id: 3, name: "非法人组织" },
      ],
      nZzlx: 3,
      sqrLx: 1,
      columnsRYLX: columnsRYLX,
      showZJLXPicker: false,
      showDatePicker: false,
      currentDate: new Date(),
      showMZPicker: false,
      showZZPicker: false,
      showGZDWPicker: false,
      minDate: new Date("1800-01-01"),
      maxDate: new Date(),
      saveBtnClickable: true, // 保存按钮是否可以点击
    };
  },
  components: {
    MyTitle,
  },
  computed: {
    ...mapGetters([
      "codeList_105000",
      "codeList_108000",
      "codeList_110000",
      "codeList_120000",
      "codeList_109000",
    ]),
  },
  methods: {

    /**
     * @function
     * @description 对接在线服务网新增——处理数据，原来写在请求里的，提出来，不然要写两遍（不知道为什么原来这么多字段弄成不一样，不易维护）
     * @param {Object} data 表单对象数据
     * @return {undefined} 无返回值
     */
    handleData(data) {
        this.formData.xm = data.cDsrxm;
        this.formData.xb = data.cDsrxb;
        this.formData.mz = data.nMz;
        this.formData.mzText = typeMz(data.nMz);
        this.formData.nl = data.nNl;
        this.formData.dtDsrbirthday = data.dtDsrbirthday;
        this.formData.dtDsrbirthdayText = data.dtDsrbirthday;
        this.formData.zjlx = data.cZjlx;
        this.formData.zjlxText = typeSfzjlx(data.cZjlx);
        this.formData.zjhm = data.cZjh;
        this.formData.gddh = data.cGh;
        let cGh = this.formData.gddh.split("-");
        this.formData.cGh1 = cGh[0];
        this.formData.cGh2 = cGh[1];
        this.formData.cGh3 = cGh[2];
        this.formData.sjhm = data.cPhoneno;
        this.formData.jcjzd = data.cTxdz;
        this.formData.qymc = data.cQymc;
        this.formData.nZzlx = data.nZzlx;
        this.formData.nZzlxText = typeZzlx(data.nZzlx);
        this.formData.tyshxydm = data.cZzjgdm;
        this.formData.dwxz = data.cDwxz;
        this.formData.dwxzText = typeGzdwlx(data.cDwxz);
        this.formData.fddbr = data.cQyfr;
        this.formData.dwdz = data.cTxdz;
        this.formData.zyfzr = data.cQyfr;
        this.sqrLx = data.cDsrlx;
        this.formData.sqrlxText = typeRylx(data.cDsrlx);
    },

    selectSqrlx() {
      this.showSqrlx = true;
    },
    onSelectSqrlx(item) {
      if (item.keyId == 1) {
        this.formData.xb = "1";
        this.formData.mz = 1;
        this.formData.mzText = "汉族";
        this.formData.zjlx = 1;
        this.formData.zjlxText = "居民身份证";
      } else {
        this.clearSQRData();
        this.formData.nZzlx = 4;
        this.formData.nZzlxText = "社会统一信用代码证";
      }
      this.initSqrData(JSON.parse(sessionStorage.getItem("bsqrId")));
      this.showSqrlx = false;
      this.formData.sqrlxText = item.text;
      this.sqrLx = item.keyId;
    },
    addSqrInfo: function () {
      this.saveBtnClickable = false;
      let bsqrId = JSON.parse(sessionStorage.getItem("bsqrId"));
      if (bsqrId && bsqrId != "undefined" && bsqrId != "") {
        // 如果sqrId有值代表是更新
        this.postData.cBqDsrid = bsqrId;
        this.postData.nValid = 1;
        this.postData.cBqId = this.bqid;
      }
      this.postData.cDsrlx = this.sqrLx;
      this.postData.cPhoneno = this.formData.sjhm;
      let ghList = [];
      for (let i = 1; i < 4; i++) {
        if (this.formData[`cGh${i}`]) {
          ghList.push(this.formData[`cGh${i}`]);
        }
      }
      this.postData.cGh = ghList.join("-");
      if (this.sqrLx == 1) {
        this.postData.cDsrxm = this.formData.xm;
        this.postData.cZjlx = this.formData.zjlx;
        this.postData.cZjh = this.formData.zjhm;
        this.postData.dtDsrbirthday = this.formData.dtDsrbirthday;
        this.postData.nNl = this.formData.nl;
        this.postData.cDsrxb = this.formData.xb;
        this.postData.nMz = this.formData.mz;
        this.postData.cTxdz = this.formData.jcjzd;
      } else {
        this.postData.nZzlx = this.formData.nZzlx;
        this.postData.nZzlxText = this.formData.nZzlxText;

        this.postData.cQymc = this.formData.qymc;
        this.postData.cZzjgdm = this.formData.tyshxydm;
        this.postData.cDwxz = this.formData.dwxz;
        this.postData.cTxdz = this.formData.dwdz;
      }
      if (this.sqrLx == 2) {
        this.postData.cQyfr = this.formData.fddbr;
      }
      if (this.sqrLx == 3) {
        this.postData.cQyfr = this.formData.zyfzr;
      }

      return this.$axios
        .post("ssbq/api/xcx/dsr?bqid=" + this.bqid, this.postData)
        .then((res) => {
          if (res.code == 204) {
            this.$notify({ type: "success", message: "操作成功" });
          } else {
            this.$notify(res.message);
          }
        })
        .catch(() => {});
    },
    addBsqrAndReturn: function () {
      const validated = this.validateFormData();
      validated.then(() => {
        this.addSqrInfo().then(() => {
          this.$router.push("/preservationInfo");
        });
      });
    },
    addBsqrAndContinue: function () {
      const validated = this.validateFormData();
      validated.then(() => {
        this.addSqrInfo().then(() => {
          setTimeout(() => {
            window.location.reload();
          }, 500);
        });
      });
    },
    onZJLXConfirm: function (value) {
      this.formData.zjlx = value.keyId;
      this.formData.zjlxText = value.text;
      this.showZJLXPicker = false;
    },
    onDatePickerConfirm: function () {
      this.currentDate = new Date(this.currentDate.setHours(8));
      this.formData.dtDsrbirthday = this.currentDate;
      this.showDatePicker = false;
      this.formData.dtDsrbirthdayText = dateFormat(
        this.formData.dtDsrbirthday,
        "yyyy-MM-dd"
      );
    },
    onMZConfirm: function (item) {
      this.formData.mz = item.keyId;
      this.formData.mzText = item.text;
      this.showMZPicker = false;
    },
    onZZConfirm: function (item) {
      console.log("--onZZConfirm 1111", item);
      this.formData.nZzlx = item.keyId;
      this.formData.nZzlxText = item.text;
      this.showZZPicker = false;
    },
    onGZDWConfirm: function (item) {
      this.formData.dwxz = item.keyId;
      this.formData.dwxzText = item.text;
      this.showGZDWPicker = false;
    },
    initSqrData: function (bsqrId, firstVisit) {
      // 对接在线服务新增——回显选择添加的诉讼案件相关人员信息
      if (sessionStorage.getItem('addPersonInfo')) {
        this.handleData(JSON.parse(sessionStorage.getItem('addPersonInfo')));
        return;
      }
      if (!bsqrId || bsqrId == "undefined") {
        return;
      }
      this.$axios
        .get("ssbq/api/bsqr?id=" + bsqrId)
        .then((res) => {
          let data = res.data;
          if (firstVisit || this.sqrLx == data.cDsrlx) {
            this.handleData(data);
          }
        })
        .catch(() => {});
    },
    clearSQRData: function () {
      let formData = this.formData;
      for (let key in formData) {
        formData[key] = "";
      }
    },
    validateFormData: function () {
      // 校验规则
      let descriptor;
      if (this.sqrLx == 1) {
        // 自然人校验规则
        descriptor = {
          xm: new XmRule(true),
          zjlx: zjlxRule,
          zjhm: new ZjhmRule(this.formData.zjlx, true),
          //dtDsrbirthday: csrqRule, // 出生日期非必填
          // mz: mzRule,
          xb: xbRule,
          // nl: new NlRule(true),
          sjhm: new PhoneRule(false),
          // gddh: new GddhRule(false),
          cGh1: new QhRule(false),
          cGh2: new DhhmRule(false),
          cGh3: new FjhRule(false),
          jcjzd: new TxdzRule(this.sqrLx, false),
        };
      }
      if (this.sqrLx == 2) {
        // 法人校验规则
        descriptor = {
          qymc: new QymcRule(true),
          nZzlx: nZzlxRule,
          // tyshxydm: new TyshxydmRule(true),
          tyshxydm: new CQyzzjgdmRule(Number(this.formData.nZzlx), true),
          // dwxz: dwxzRule,
          fddbr: new QyfrRule(this.sqrLx, true),
          sjhm: new PhoneRule(false),
          // gddh: new GddhRule(false),
          cGh1: new QhRule(false),
          cGh2: new DhhmRule(false),
          cGh3: new FjhRule(false),
          dwdz: new TxdzRule(this.sqrLx, true),
        };
      }
      if (this.sqrLx == 3) {
        // 非法人校验规则
        descriptor = {
          qymc: new QymcRule(true),
          nZzlx: nZzlxRule,
          // tyshxydm: new TyshxydmRule(true),
          tyshxydm: new CQyzzjgdmRule(Number(this.formData.nZzlx), true),
          // dwxz: dwxzRule,
          zyfzr: new QyfrRule(this.sqrLx, true),
          sjhm: new PhoneRule(false),
          // gddh: new GddhRule(false),
          cGh1: new QhRule(false),
          cGh2: new DhhmRule(false),
          cGh3: new FjhRule(false),
          dwdz: new TxdzRule(this.sqrLx, true),
        };
      }
      if (this.formData.nl && this.formData.nl > 120) {
        this.$notify("年龄不得大于120");
        return;
      }
      let validated = validate(descriptor, this.formData);
      return validated;
    },
    identifyAnalyzer: function () {
      if (this.formData.zjlx != 1) {
        // 只有身份证才走下方流程
        return;
      }
      let zjhm = this.formData.zjhm;
      let correct = checkIdentify(zjhm);
      if (correct) {
        // 身份证号格式正确, 向服务器查询 生日, 性别, 年龄 信息
        getIDData(zjhm).then((res) => {
          let data = res.data;
          this.formData.dtDsrbirthday = data.cBirthdate;
          this.formData.dtDsrbirthdayText = data.cBirthdate;
          this.formData.nl = data.nAge;
          this.formData.xb = data.cSex;
        });
      }
    },
    initCodeType() {
      /* 证件类型 */
      this.$store.dispatch("GetCodeType", 105000);
      /* 单位性质 */
      this.$store.dispatch("GetCodeType", 108000);
      /* 性别 */
      this.$store.dispatch("GetCodeType", 110000);
      /* 民族 */
      this.$store.dispatch("GetCodeType", 120000);
      /* 证照类型 */
      this.$store.dispatch("GetCodeType", 109000);
    },
  },
  created() {
    this.initCodeType();
    let bsqrId = JSON.parse(sessionStorage.getItem("bsqrId"));
    this.bsqrId = bsqrId;
    this.initSqrData(bsqrId, true);
    let currentBqid = JSON.parse(sessionStorage.getItem("currentBqid"));
    this.bqid = currentBqid;
  },
};
</script>